import Base from "./base";

export default class VevopayPopyPara extends Base {
	makeExternalPayment(newStep) {
		const { iban, stake } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				processType: "popy",
				paymentType: "popy",
				iban,
				amount: stake,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { iban, stake } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				processType: "popy",
				paymentType: "popy",
				iban,
				amount: stake,
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}
}
